import config from "../../config/config";
import { Manage_operator_service } from "../services/Manage_operator_service";
import { MessageBox, Loading } from 'element-ui';
import router from "../router/router"
const state = {
    total: 0,
    operators: [],
    select_lists: [],
    prepare: null,
    operator_info : null ,
    loading: false,
    preview_img : '',
};
const actions = {
    async add_permission({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_operator_service.add_permission(data);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_operator' })
            }).catch(() => {
                router.push({ name: 'Manage_operator' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async search_table({ commit }, formTable) {
        commit('LOADING', true)
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_operator_service.search_table(formTable);
        if (result.status === 200) {
            commit('UPDATE_TABLE', result.data)
            setTimeout(() => {
                commit('LOADING', false)
                loadingInstance.close()
            }, 250);
        } else {
            setTimeout(() => {
                commit('LOADING', false)
                loadingInstance.close()
            }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async delete_permission({ commit }, row_data) {
        let result = await Manage_operator_service.delete_permission(row_data);
        if (result.status === 200) {
            commit('REMOVE_ROW', row_data.id)
            MessageBox.confirm('ลบข้อมูลเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            })
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async getAvailableOperator({ commit }) {
        let result = await Manage_operator_service.getAvailableOperator()
        if (result.status === 200) {
            commit('UPDATE_LIST', result.data)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async getCompanyList({ commit }) {
        let result = await Manage_operator_service.getCompanyList()
        if (result.status === 200) {
            commit('UPDATE_LIST', result.data)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async edit_permission({ commit }, formdata) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_operator_service.edit_permission(formdata)
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('แก้ไขข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_operator' })
            }).catch(() => {
                router.push({ name: 'Manage_operator' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async set_edit_info({commit}, formdata){
        let result = await Manage_operator_service.getOperatorById(formdata)
        if(result.status == 200){
            commit('SET_OPERATOR_INFO', result.data)
            if(result.data[0]) commit('SET_PREVIEW_IMG', config.API_URL+result.data[0].profile_img)
            router.push({name : 'Edit_operator' })
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    }

};

const mutations = {
    UPDATE_TABLE(state, data) {
        state.operators = data
        state.total = data[0] ? data[0].total : 0
    },
    REMOVE_ROW(state, admin_id) {
        var index = state.operators.findIndex(row => row.admin_id == admin_id)
        state.operators.splice(index, 1)
        state.total = state.total - 1
    },
    UPDATE_LIST(state, data) {
        state.select_lists = data.result
    },
    PREPARE_EDIT(state,data){
        state.prepare = data
    },
    LOADING(state, status){
        state.loading = status
    },
    SET_OPERATOR_INFO(state, data){
        state.operator_info = data[0]
        let permission = {
            Manage_internet : [],
            Manage_mobile : [],
            Contact_admin : []
        }
        state.operator_info.role_permission = Object.assign(permission, JSON.parse(state.operator_info.role_permission)) 
    },
    SET_PREVIEW_IMG(state, url){
        state.preview_img = url
    }
};

export const Manage_operator = {
    namespaced: true,
    state,
    actions,
    mutations
};